const state = () => ({
  mcStatuses: {
    booked: "Записан",
    inWork: "В работе",
    success: "Завершен",
    cancel: "Отменен",
    finished: "Завершил работу",
  },
  mcStatusesWithTranslate: {
    ru: {
      booked: "Записан",
      inWork: "В работе",
      success: "Завершен",
      cancel: "Отменен",
      finished: "Завершил работу",

    },
    en: {
      booked: "booked",
      inWork: "In progress",
      success: "Completed",
      cancel: "Cancelled",
      finished: "Finished work",
    },
    tr: {
      booked: "Rezerve edildi",
      inWork: "Devam etmekte",
      success: "Tamamlanmış",
      cancel: "İptal edildi",
      finished: "İş bitti",
    },
    es: {
      booked: "Registrado",
      inWork: "Tomada",
      success: "Terminado",
      cancel: "Cancelado",
      finished: "Terminé trabajo",
    },
    id: {
      booked: "Dipesan",
      inWork: "Sedang Berlangsung",
      success: "Selesai",
      cancel: "Dibatalkan",
      finished: "Pekerjaan selesai",
    },
    pt: {
      booked: "Reservado",
      inWork: "Em progresso",
      success: "Concluído",
      cancel: "Cancelado",
      finished: "Trabalho concluído"
    }
  },
  mimkStatuses: {
    noWork: {
      title: "Нерабочее время",
      statusMatch: "MimkStatus.non_working_hours",
      translateStatusTitle: "status.nonWorking",
    },
    readyToTake: {
      title: "Готов взять клиента",
      statusMatch: "MimkStatus.waiting_for_client",
      translateStatusTitle: "status.waitingClient",
    },
    working: {
      title: "Работает с клиентом",
      statusMatch: "MimkStatus.working_with_client",
      translateStatusTitle: "status.working",
    },
    doNotStartMc: {
      title: "Еще не начал МК",
      statusMatch: "MimkStatus.has_not_started_mk",
      translateStatusTitle: "status.notStarted",
    },
    finishedWork: {
      title: "Завершил работу",
      statusMatch: "MimkStatus.finished_work",
      translateStatusTitle: "status.finishedWork",
    },
    startenInTheNextSlot: {
      title: "startenInTheNextSlot",
      statusMatch: "MimkStatus.start_work_in_next_slot",
      translateStatusTitle: "status.startenInTheNextSlot",
    },
  },
  m1Statuses: {
    noWork: {
      title: "Нерабочее время",
      statusMatch: "M1Status.non_working_hours",
      translateStatusTitle: "status.nonWorking",
    },
    readyToTake: {
      title: "Готов взять клиента",
      statusMatch: "M1Status.waiting_for_client",
      translateStatusTitle: "status.waitingClient",
    },
    working: {
      title: "Работает с клиентом",
      statusMatch: "M1Status.working_with_client",
      translateStatusTitle: "status.working",
    },
  },
});

export default {
  namespaced: true,
  state,
};
